import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { CheckoutContainer, LoginContainer, MainContainer } from "./containers";
import { Alert, Header, PaymentSuccess } from "./components";
import { getAuth } from "firebase/auth";
import { app } from "./config/firebase.config";
import { getAllCartItems, validateUserJWTToken } from "./api";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "./context/actions/userActions";
import { fadeInOut } from "./animations";
import { Dashboard } from "./containers";
import { setCartItems } from "./context/actions/cartActions";
import ThanhToanHoaDon from "./containers/ThanhToanHoaDon";
const MainLoader = React.lazy(() => import("./components/MainLoader"));

const App = () => {
  const firebaseAuth = getAuth(app);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const alert = useSelector((state) => state.alert);
  const getUserToken = async () => {
    return new Promise((resolve, reject) => {
      firebaseAuth.onAuthStateChanged((cred) => {
        if (cred) {
          cred.getIdToken()
            .then((token) => {
              resolve(token);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          reject(new Error("User is not authenticated"));
        }
      });
    });
  };

  useEffect(() => {
    setIsLoading(true);

    getUserToken()
      .then((token) => {
        localStorage.setItem("userToken", token);
        validateUserJWTToken(token)
          .then((data) => {
            if (data) {
              getAllCartItems(data.data?.user_id)
                .then((items) => {
                  dispatch(setCartItems(items));
                })
                .catch((error) => {
                  console.error("Error fetching cart items:", error);
                });
            }
            dispatch(setUserDetails(data));
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error validating JWT token:", error);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error getting user token:", error);
        setIsLoading(false);
      });
  }, []);


  const shouldShowHeader = location.pathname !== "/login" && !location.pathname.startsWith("/dashboard") && !location.pathname.startsWith("/thanhtoan");

  return (
    <AnimatePresence>
      <div className="w-screen h-auto flex flex-col bg-primary">
        {shouldShowHeader && <Header />}
        <main className={`${shouldShowHeader && "mt-14 md:mt-20 px-4 md:px-16 py-4"} w-full`}>
          {isLoading && (
            <React.Suspense fallback={<div>Loading...</div>}>
              <motion.div {...fadeInOut} className="fixed z-50 inset-0 bg-gray-200 backdrop-blur-md flex items-center justify-center w-full">
                <MainLoader />
              </motion.div>
            </React.Suspense>
          )}
          <Routes>
            <Route path="/dashboard/*" element={< Dashboard />} />
            <Route path="/*" element={<MainContainer />} />
            <Route path="/login" element={<LoginContainer />} />
            <Route path="/checkout" element={<CheckoutContainer />} />
            <Route path="/paymentSuccess" element={<PaymentSuccess />} />
            <Route path="/thanhtoan" element={<ThanhToanHoaDon />} />
          </Routes>
          {alert?.type && (
            <Alert
              type={alert?.type}
              message={
                <div dangerouslySetInnerHTML={{ __html: alert?.message }} />
              }
            />
          )}

        </main>
      </div>
    </AnimatePresence>
  );
};

export default App;